/**
 * Classic Site member read API — Phase 3 audit wrappers (read-only).
 *
 * Owned listings verification (Django hoodie/api_views.py DirectoryEntryViewSet):
 *
 * | Question | Answer |
 * |----------|--------|
 * | Owner filter (?mine, ?owner=me, ?administrator) | **No** — not implemented |
 * | Auth changes queryset to owned only | **No** — same public_listings base |
 * | ?favorites= | Returns favorited listings, **not** owned |
 * | Disabled/inactive for owner | **Excluded** — public_listings filters enabled=True |
 * | administrator / enabled in serializer | **No** — not in DirectoryEntrySerializer.fields |
 *
 * Conclusion: GET /api/hoodie/listings/ cannot safely power "my listings" in React.
 */

import { hoodieFetchSessionJson } from "../../../api/hoodieClient";

/** @typedef {'blocked'|'verified'} OwnedListingsReadStatus */

/**
 * Phase 3 verification result — static audit from Django source (not live staging).
 */
export const OWNED_LISTINGS_VERIFICATION = {
  status: "blocked",
  endpoint: "GET /api/hoodie/listings/",
  method: "GET",
  auth: "session optional (favorites only requires session)",
  credentials: "include for session; public GET uses omit in hoodieFetch",
  verified: "django-source-audit",
  reasons: [
    "Queryset base is DirectoryEntry.public_listings (enabled=True only).",
    "No owner-scoped query param (?mine, ?owner=me, ?administrator=me).",
    "?favorites= returns recommendations, not owned listings.",
    "administrator and enabled are not in DirectoryEntrySerializer.",
    "Cannot infer ownership client-side without administrator field.",
  ],
  legacyUrl: "/member/accounts/profile/",
};

/**
 * Attempt session-authenticated listings fetch — for diagnostics only.
 * Do NOT use results as "my listings"; returns public enabled listings.
 *
 * @returns {Promise<{ data: object|null, ok: boolean, status: number }>}
 */
export async function fetchListingsSessionDiagnostic() {
  const { data, response, ok } = await hoodieFetchSessionJson("listings/?limit=5");
  return { data, ok, status: response.status };
}
